import { EditPoint } from "./EditPoint";
import { FenceRectangle } from "./FenceRectangle";
import { FenceTriangle } from "./FenceTriangle";

export class FenceStatic {
	public static TRIANGLE: number = 1;
	public static RECTANGLE: number = 2;
	public static CIRCLE: number = 2;
	public static RECT_MIN_WIDTH: number = 10;
	public static RECT_MIN_HEIGHT: number = 10;
	public static iCurrentFence: number;
	public static deselectAllFences(): void {
		//deselect fencetriangle
		// if (this.Global.pageInputFenceTriangle.fenceCurrent !== null) {
		// 	this.Global.pageInputFenceTriangle.fenceCurrent.deselect(true);
		// }
		//deselect fencerectangle
		// if (this.Global.pageInputFenceRectangle.fenceCurrent !== null) {
		// 	this.Global.pageInputFenceRectangle.fenceCurrent.deselect(true);
		// }
	}
	public static createEditPoints(fence: Object): void {
		// var editp: EditPoint;
		// if (fence instanceof FenceRectangle) {
		// 	var fenceRect: FenceRectangle = <FenceRectangle>fence;

		// } else if (fence instanceof FenceTriangle) {
		// 	var fenceTria: FenceTriangle = <FenceTriangle>fence;
		// 	editp = new EditPoint(fenceTria.p1.x, fenceTria.p1.y);
		// 	// fenceTria.addChild(editp);
		// 	editp = new EditPoint(fenceTria.p2.x, fenceTria.p2.y);
		// 	// fenceTria.addChild(editp);
		// 	editp = new EditPoint(fenceTria.p3.x, fenceTria.p3.y);
		// 	// fenceTria.addChild(editp);
		// }
	}
	public static removeEditPoints(fence: Object): void {
		// var editp: EditPoint;
		// if (fence instanceof FenceRectangle) {
		// 	var fenceRect: FenceRectangle = <FenceRectangle>fence;

		// } else if (fence instanceof FenceTriangle) {
		// 	var fenceTria: FenceTriangle = <FenceTriangle>fence;
		// 	// fenceTria.removeAllChildren();
		// }
	}
}